import { useFormContext, Controller } from 'react-hook-form';

import { TextField, TextFieldProps } from '@mui/material';
import { handleCurrent } from '@/utils/regex';

type Props = TextFieldProps & {
  isZero?: boolean;
  control?: any;
  name: string;
  isForm?: boolean;
};

export default function RHFTextField({
  name,
  helperText,
  isZero,
  control,
  fullWidth = true,
  isForm = true,
  ...other
}: Props) {
  if (!isForm) return <TextField fullWidth={fullWidth} {...other} />;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { control: controlContext } = useFormContext();

  return (
    <Controller
      name={name}
      control={control ?? controlContext}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth={fullWidth}
          value={
            // eslint-disable-next-line no-nested-ternary
            typeof field.value === 'number' && field.value === 0 && !isZero
              ? ''
              : other.type === 'current'
              ? handleCurrent(field.value as String, true)
              : field.value
          }
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}
